import styled, { keyframes } from 'styled-components';

const rotateBackground = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const changeShadow = keyframes`
  0% {
        box-shadow: 0px 0px 20px 4px #0d86ff50;
    }
    50% {
        box-shadow: 0px 0px 20px 2px rgb(148, 238, 152);
    }
    100% {
        box-shadow: 0px 0px 20px 4px #44d788;
    }
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  padding: 15px;
  border-radius: 32px 32px 0 0;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(45deg, #44d788, #2e7d32, #1c4d1e);
  background-size: 300% 300%;
  animation: ${rotateBackground} 3s ease-in-out infinite;
`;

export const Button = styled.button`
  display: flex;
  margin: 0;
  padding: 0;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;

  border-radius: 100px;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  box-shadow: 0 -5px 10px #0d86ff50, 0 5px 20px #44d788;
  background: linear-gradient(45deg, #44d788, #2e7d32, #1c4d1e);
  background-size: 300% 300%;

  animation-name: ${rotateBackground}, ${changeShadow};
  animation-timing-function: ease-in-out, ease-in-out;
  animation-duration: 2s, 1.5s;
  animation-iteration-count: infinite, infinite;
`;
